// extracted by mini-css-extract-plugin
export default {"articleContainer":"ArticleContainer_articleContainer__6yZqR"};